export const OPEN_DRAWER = 'OPEN_DRAWER'
export const CLOSE_DRAWER = 'CLOSE_DRAWER'

interface OpenDrawerAction {
    type: typeof OPEN_DRAWER
}

interface CloseDrawerAction {
    type: typeof CLOSE_DRAWER
}

export type ActionType = OpenDrawerAction | CloseDrawerAction

export class Actions {

    static open(): OpenDrawerAction {
        return {
            type: OPEN_DRAWER
        }
    }

    static close(): CloseDrawerAction {
        return {
            type: CLOSE_DRAWER
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/drawer.ts